import { render, staticRenderFns } from "./TeamArrivalAreaDetails.vue?vue&type=template&id=0a285726&scoped=true&"
import script from "./TeamArrivalAreaDetails.vue?vue&type=script&lang=js&"
export * from "./TeamArrivalAreaDetails.vue?vue&type=script&lang=js&"
import style0 from "./TeamArrivalAreaDetails.vue?vue&type=style&index=0&id=0a285726&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a285726",
  null
  
)

export default component.exports